<template>
    <v-container class="pa-5 d-flex flex-column" fluid style="height: 100%">
        <page-title>
            Zamówienia - realizacja na dzień
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end" dense>
            <v-col cols="12" md="4" lg="2">
                <v-menu
                    v-model="menuFrom"
                    :loading="actionLoading.getPlacedOrders"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            :value="setMonthName(filters.date__gte)"
                            label="Data"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                            @input="changeFilter"
                        >
                            <template slot="append-outer">
                                <div class="d-flex flex-wrap">
                                    <v-btn
                                        icon
                                        x-small
                                        class="mt-n2"
                                        data-sentry-label="Zmiana daty rankingu"
                                        @click="getMonth('forward')"
                                    >
                                        <v-icon>
                                            mdi-chevron-up
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        x-small
                                        data-sentry-label="Zmiana daty rankingu"
                                        @click="getMonth('previous')"
                                    >
                                        <v-icon>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.date__gte"
                        type="month"
                        @change="changeFilter(false)"
                        @input="menuFrom = false"
                    />
                </v-menu>
            </v-col>
        </v-row>

        <v-row justify="end">
            <v-col cols="auto">
                <v-btn
                    text
                    small
                    data-sentry-label="Generuj raport"
                    :loading="actionLoading.generateReport"
                    @click="generateReport"
                >
                    <v-icon small left color="red">
                        mdi-file-pdf
                    </v-icon>
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-card
            width="100%"
            height="100%"
            class="d-flex flex-column"
            :loading="actionLoading.getPlacedOrders"
        >
            <v-card-text style="height: 99.9%; width: 100%; position: relative">
                <canvas ref="chartContainer" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'

import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'

import { errorHandler } from '@/utils/errorHandler'
import './../../../../public/fonts/roboto/Roboto-Light.js'

import { Chart, BarController, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { jsPDF } from 'jspdf'
import { endOfMonth, addMonths, subMonths, format, getDaysInMonth } from 'date-fns'
import html2canvas from 'html2canvas'

export default {
    name: 'PlacedOrders',
    components: {
        PageTitle
    },
    mixins: [filters, dateFormatter],
    data() {
        return {
            chart: null,
            chartData: {
                labels: [],
                data: []
            },
            menuFrom: false,
            actionLoading: {
                getPlacedOrders: false,
                generateReport: false
            },
            monthDays: 0,
            allLabels: [
                '01', '02', '03', '04', '05', '06',
                '07', '08', '09', '10', '11', '12',
                '13', '14', '15', '16', '17', '18',
                '19', '20', '21', '22', '23', '24',
                '25', '26', '27', '28', '29', '30',
                '31'
            ]
        }
    },
    computed: {
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.orders.placedOrders.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if ( filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (item == 'date__gte') {
                        const selectedMonth = new Date(filters['date__gte'])
                        const firstDayOfMonth = new Date( selectedMonth.getFullYear(), selectedMonth.getMonth(), 1)
                        const lastDayOfTheMonth = endOfMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth()))

                        filters['date__lte'] = `${format(lastDayOfTheMonth, 'YYYY-MM-DD')}`
                        filters['date__gte'] = `${format(firstDayOfMonth, 'YYYY-MM-DD')}`
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    mounted() {
        this.setDefaultLabels()
        this.setDiagram()
        this.getPlacedOrders()
    },
    destroyed() {
        this.chart.destroy()
    },
    methods: {
        async getPlacedOrders() {
            this.actionLoading.getPlacedOrders = true

            return await this.$store.dispatch('reportsAndAnalysis/orders/getPlacedOrders', {
                query: this.filterQuery
            })
                .then(response => {
                    this.setLabels(response.data.results)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getPlacedOrders = false
                })
        },
        getMonthDays() {
            const selectedMonth = new Date(this.filters['date__gte'])

            return getDaysInMonth(selectedMonth)
        },
        setMonthName() {
            if (this.filters.date__gte) {
                return new Date(this.filters.date__gte).toLocaleString('pl', { month: 'long', year: 'numeric'})
            }
        },
        getMonth(month) {
            let result = null

            if (Date.parse(this.filters.date__gte)) {
                const selectedMonth = new Date(this.filters['date__gte'])

                if (month === 'previous') {
                    result = subMonths(selectedMonth, 1)
                } else if (month === 'forward') {
                    result = addMonths(selectedMonth, 1)
                }
            }

            this.filters['date__gte'] = format(result, 'YYYY-MM')
            this.getPlacedOrders()
        },
        setDefaultLabels() {
            const days = getDaysInMonth(new Date())
            let labelsCopy = [...this.allLabels]

            if (days !== labelsCopy.length) {
                labelsCopy.splice(days - labelsCopy.length)
            }
            this.chartData.labels = labelsCopy
        },
        setLabels(response) {
            this.monthDays = this.getMonthDays()
            let labelsCopy = [...this.allLabels]

            if (this.monthDays !== labelsCopy.length) {
                labelsCopy.splice(this.monthDays - labelsCopy.length)
            }
            this.chart.data.labels = labelsCopy
            this.setChartData(response)
        },
        setDiagram() {
            Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, ChartDataLabels, Legend)

            const chartContainer = this.$refs.chartContainer

            this.chart = new Chart(chartContainer, {
                type: 'bar',
                plugins: [ChartDataLabels],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            suggestedMax: 500,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 50
                            },
                            title: {
                                display: true,
                                text: 'Liczba zamówień',
                                font: {
                                    size: 18
                                }
                            }
                        },
                        x: {
                            title: {
                                display: true,
                                text: 'Dni miesiąca',
                                font: {
                                    size: 18
                                }
                            }
                        },
                    },
                    plugins: {
                        datalabels: {
                            display(context) {
                                return (
                                    context.dataset.data[context.dataIndex] > 0
                                )
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 4,
                            font: {
                                weight: 'bold',
                                size: 14
                            }
                        },
                        legend: {
                            position: 'bottom',
                            labels : {
                                padding: 40,
                                font: {
                                    size: 16
                                }
                            }

                        }
                    }
                },
                data: {
                    labels: this.chartData.labels,
                    datasets: [
                        {
                            label: 'Online',
                            backgroundColor: '#2196F3',
                        },
                        {
                            label: 'WMD',
                            backgroundColor: '#f37e21',
                        },
                        {
                            label: 'Offline',
                            backgroundColor: '#4caf50',
                        },
                    ]
                }
            })
        },
        setChartData(ordersByDay) {
            const locations = [{ location: 1 }, { location: 2 }, { location: 3 }] // 1 - Online, 2 - WMD, 3 - Offline
            const locationsOrders = locations.map(counts =>
                Object.assign(counts, { ordersSum: [...new Array(this.monthDays)].map((item, index) => {
                    const day = (ordersByDay.find(item =>
                        new Date(item.date).getDate() === index + 1 && item.localization === counts.location
                    ))

                    return typeof day !== 'undefined' ? day.count : 0
                }
                )})
            )

            this.chart.data.datasets = [
                {
                    label: 'Online',
                    backgroundColor: '#2196F3',
                    data: locationsOrders[0].ordersSum,
                    borderWidth: 0,
                    borderRadius: 5,
                },
                {
                    label: 'WMD',
                    backgroundColor: '#f37e21',
                    data: locationsOrders[1].ordersSum,
                    borderWidth: 0,
                    borderRadius: 5,
                },
                {
                    label: 'Offline',
                    backgroundColor: '#4caf50',
                    data: locationsOrders[2].ordersSum,
                    borderWidth: 0,
                    borderRadius: 5,
                }
            ]
            if (this.$refs.chartContainer) this.chart.update()
        },
        changeFilter() {
            this.actionLoading.getPlacedOrders = true

            this.$store.dispatch('reportsAndAnalysis/orders/getPlacedOrders', {
                query: this.filterQuery
            })
                .then(response => {
                    this.setLabels(response.data.results)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getPlacedOrders = false
                })
        },
        generateReport() {
            this.actionLoading.generateReport = true

            html2canvas(this.$refs.chartContainer)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/png'),
                        doc = new jsPDF({
                            orientation: 'landscape'
                        })

                    doc.setFont('Roboto-Light')
                    doc.text(`Zamówienia - realizacja na dzień w miesiącu: ${this.setMonthName()}`, 10, 10)
                    doc.addImage(imgData, 'PNG', 10, 40, 275, 130)
                    doc.setFontSize(10)
                    doc.text( `Wygenerowano: ${this.formatDate(new Date())}`, 10, 200)

                    window.open(doc.output('bloburl'), '_blank')
                    this.actionLoading.generateReport = false
                })
                .catch(() => {
                    this.actionLoading.generateReport = false
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisOrdersOrders' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>
